export const stayResourcePermissions = {
  access: "resource.stay:access",
  delete: "resource.stay:delete",
  manage: "resource.stay:manage",
  manageMedia: "resource.stay:manage",
  reviewGeo: "resource.stay:manage",
  reviewResource: "resource.stay:manage",
  manageCapability: "resource.stay:manage",
} as const;

export const stayResourceStatusOptions = [
  { label: "启用", value: "active" },
  { label: "停用", value: "inactive" },
] as const;

export const stayHotelTypeOptions = [
  { label: "酒店", value: "酒店" },
  { label: "客栈", value: "客栈" },
  { label: "民宿", value: "民宿" },
  { label: "基地", value: "基地" },
] as const;

export const stayRoomTypeOptions = [
  { label: "标间", value: "标间" },
  { label: "三人间", value: "三人间" },
  { label: "大床房", value: "大床房" },
  { label: "家庭房", value: "家庭房" },
] as const;

export const stayMediaSceneOptions = [
  { label: "封面", value: "cover" },
  { label: "房型图片", value: "room" },
  { label: "入口", value: "entrance" },
  { label: "大堂", value: "lobby" },
  { label: "周边", value: "surroundings" },
  { label: "餐厅", value: "restaurant" },
  { label: "非团队区域", value: "non_team" },
  { label: "用餐", value: "dining" },
  { label: "其他", value: "other" },
] as const;

export const stayProcurementChannelOptions = [
  { label: "直采资源方", value: "direct_resource_provider" },
  { label: "地接采购", value: "ground_operator" },
  { label: "其他中间商", value: "other_intermediary" },
  { label: "未知", value: "unknown" },
] as const;

export const stayCooperationStatusOptions = [
  { label: "候选", value: "candidate" },
  { label: "洽谈中", value: "negotiating" },
  { label: "已核验", value: "verified" },
  { label: "合作中", value: "active" },
  { label: "暂停", value: "paused" },
  { label: "终止", value: "terminated" },
] as const;
